module.exports = __webpack_public_path__ + "/fonts/mailer.ed349785.gif";